import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './Game.css';
import airplaneDark from './assets/airplane-dark.png';
import airplaneLight from './assets/airplane-light.png';
import airplaneBlue from './assets/airplane-blue.png';
import backgroundDark from './assets/bckg_game_dark.png';
import backgroundLight from './assets/bckg_game_light.png';
import backgroundBlue from './assets/bckg_game_blue.png';
import footer from './assets/footer.png';
import stripesBlue from './assets/stripes_blue.png';
import stripesLight from './assets/stripes_light.png';
import stripesDark from './assets/stripes_dark.png';

const translations = {
  en: {
    connectionMessage: "The connection between the account and the program is established"
  },
  ru: {
    connectionMessage: "Связь между учетной записью и программой установлена"
  },
  es: {
    connectionMessage: "Se ha establecido la conexión entre la cuenta y el programa."
  }
};

const Game = () => {
  const location = useLocation();
  const { style = 'dark', language = 'en', inputText = '' } = location.state || {};
  const [connectionMessage, setConnectionMessage] = useState(false);
  const [multiplier, setMultiplier] = useState('1.00x');

  const host_server = '/get_multiplier';

  const [animate, setAnimate] = useState(false);
  const [showWatermark, setShowWatermark] = useState(false);

  const getBackgroundAndLogo = () => {
    switch (style) {
      case 'light':
        return { backgroundImage: backgroundLight, airplaneLogo: airplaneLight, footerImage: footer, textColor: 'black', watermarkText: 'black', stripesImage: stripesLight };
      case 'blue':
        return { backgroundImage: backgroundBlue, airplaneLogo: airplaneBlue, footerImage: footer, textColor: 'white', watermarkText: 'black', stripesImage: stripesBlue };
      default:
        return { backgroundImage: backgroundDark, airplaneLogo: airplaneDark, footerImage: footer, textColor: 'white', watermarkText: 'black', stripesImage: stripesDark };
    }
  };

  const { backgroundImage, airplaneLogo, footerImage, textColor, watermarkText, stripesImage } = getBackgroundAndLogo();
  const t = translations[language] || translations.en;

  useEffect(() => {
    setConnectionMessage(true);
    const messageTimeout = setTimeout(() => {
      setConnectionMessage(false);
      if (inputText) {
        setShowWatermark(true);
      }
    }, 2000);

    const updateMultiplier = async () => {
      try {
        const response = await axios.get(host_server);
        const newMultiplier = response.data.result + 'x';
        setMultiplier(newMultiplier);
        setAnimate(true);
      } catch (error) {
        console.error('There was an error fetching the multiplier:', error);
      }
    };

    updateMultiplier();
    const intervalId = setInterval(updateMultiplier, 3000);

    return () => {
      clearInterval(intervalId);
      clearTimeout(messageTimeout);
    };
  }, [inputText]);

  useEffect(() => {
    if (multiplier === '0x') {
      setAnimate(false);
    }
  }, [multiplier]);

  return (
    <div className={`game-container ${style}`} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="rotating-background" style={{ backgroundImage: `url(${stripesImage})` }}></div>
      {connectionMessage && (
        <div className={`connection-message ${connectionMessage ? 'visible' : ''}`}>
          {t.connectionMessage}
        </div>
      )}
      {showWatermark && (
        <div className="input-text-display" style={{ color: watermarkText }}>
          {inputText}
        </div>
      )}
      <img src={airplaneLogo} alt="Airplane" className={`game-airplane-logo ${animate ? 'animate' : ''}`} />
      <div className={`circles ${animate ? 'animate' : ''}`}>
        <div id="loader">
          <div className="dot a"></div>
          <div className="dot b"></div>
          <div className="dot c"></div>
          <div className="dot d"></div>
          <div className="dot e"></div>
          <div className="dot f"></div>
          <div className="dot g"></div>
          <div className="dot h"></div>
        </div>
        <div className="multiplier" style={{ color: textColor }}>{multiplier}</div>
      </div>
      <img src={footerImage} alt="Footer" className="game-footer-image" />
    </div>
  );
};

export default Game;
 
